export const GET_USERCONFIG_INFO = 'GET_USERCONFIG_INFO';
export const SET_USERCONFIG_INFO = 'SET_USERCONFIG_INFO';
export const ADD_USERCONFIG = 'ADD_USERCONFIG';
export const ADD_SUCCESS = 'ADD_SUCCESS';
export const UPDATE_USERCONFIG = 'UPDATE_USERCONFIG';
